import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { pushWithStoredSearch } from 'services/router/actions';

interface Props {
    children: React.ReactNode | string;
    pathname: string;
    pushWithStoredSearch: Function;
    buttonProps?: {};
}

export class ButtonWithStoredSearch extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        const { pathname, ...props } = this.props;
        props.pushWithStoredSearch(pathname);
    };

    render() {
        const { pathname, children, buttonProps = {} } = this.props;

        return (
            <Button href={pathname} onClick={this.handleClick} {...buttonProps}>
                {children}
            </Button>
        );
    }
}

export default connect(
    null,
    { pushWithStoredSearch }
)(ButtonWithStoredSearch);
